'use strict';

const _ = require('lodash'),
    ajax = require('./modules/ajax'),
    ritualsFormHelper = require('./rituals-form-helper'),
    recaptchaConfig = require('./recaptchaConfig');

    const elements = {
    newsletterSubscribeForm: $('.newsletter-subscribe-form'),
    stores: []
};
const gtm = require('./modules/google').tagManager;
const Resources = window.Resources || {};

exports.init = function () {
    getStoreData(function (data) {
        if (!!data && data !== null) {
            _.each(data, function(store){
                const item = {};
                item['value'] = store.name;
                item['ID'] = store.ID;
                item['label'] = store.name;
                item['storeNumber'] = store.storeNumber;
                elements.stores.push(item);
            });
        }
        $('input[id$="_favoriteStoreSearch"]').autocomplete({
            source: elements.stores,
            minLength: 3, // min char count to show suggestions
            select: function (event, ui) {
                AutoCompleteSelectHandler(event, ui);
            }
        }).bind('keyup', function(){
            $('input[id$="_favoriteStoreID"]').val('');
            $(this).autocomplete('search');
        });
    });

    ritualsFormHelper.init();
    recaptchaConfig.defaultInitializationForFormById('newsletterSubscriptionForm');
};

const AutoCompleteSelectHandler = function (event, ui){
    const selectedObj = ui.item;
    $('input[id$="_favoriteStoreID"]').val(selectedObj.storeNumber);
};

const getStoreData = function (callback) {
    // load store name and id
    ajax.getJson({
        url: Urls.getStoresBasicData,
        dataType: 'json',
        callback: callback
    });
};

$(document).on('click', '.newsletter-submit', function () {
    const email = $('input.email').val();
    const regex =
        /^((")("[^"]+?"@)|(([0-9a-zA-Z_]((\.(?!\.))|[-!#\$%&'\*\+\/=\?\^`\{\}\|~\w])*)(?:[0-9a-zA-Z_-])@))((\[)(\[(\d{1,3}\.){3}\d{1,3}\])|(([0-9a-zA-Z][-0-9a-zA-Z]*[0-9a-zA-Z]*\.)+[a-zA-Z0-9]{2,17}))$/;
    const isValid = regex.test(email.trim());
    const errorMessage = !email ? Resources.VALIDATE_REQUIRED : !isValid ? Resources.VALIDATE_EMAIL : null;
    if (errorMessage) {
        gtm.pushDataLayerEvent({
            event: 'form_field_error',
            error_type: 'form_field_error',
            error_message: errorMessage,
            error_code: null,
            content_name: 'newsletter subscription'
        });
    }
});
